var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('svg',{ref:"gantt"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1eb8e585","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/portal/customerprojects/frappe-gantt.vue
// module id = 1534
// module chunks = 4